<template>
  <div
    class="whatsapp-btn w-12 h-12 bg-blue-500 text-white rounded-full flex items-center justify-center shadow-lg cursor-pointer hover:bg-blue-600 transition-colors"
    @click="openWhatsApp"
  >
    <i class="fab fa-whatsapp text-2xl"></i>
    <span class="ping-effect"></span>
    <span class="wave-effect"></span>
  </div>
</template>

<script setup>
const openWhatsApp = () => {
  window.open("https://chat.whatsapp.com/IVhpkdhJWzE19BZGYQiqlV", "_blank");
};
</script>

<style scoped>
/* Ensure the WhatsApp icon uses FontAwesome */
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css");

.whatsapp-btn {
  position: relative;
  animation: pulse 2s infinite;
  overflow: visible;
}

.ping-effect {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(59, 130, 246, 0.7);
  z-index: -1;
  animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
}

.wave-effect {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid rgba(59, 130, 246, 0.8);
  z-index: -1;
  animation: wave 2s linear infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
}

@keyframes ping {
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes wave {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.8);
    opacity: 0;
  }
}
</style>
